module.exports = ".form-control{line-height:1em}\n"